var _react_refresh_temp_1;
import { z } from 'zod';
export const UNKNOWN_ENUM_VALUE = '$unknown';
export const unknownEnumValueSchema = z
    .string()
    .pipe(_react_refresh_temp_1 = z.literal(UNKNOWN_ENUM_VALUE));
$RefreshReg$(_react_refresh_temp_1, "unknownEnumValueSchema$z\n    .string()\n    .pipe");
export const enumParser = (values) => z
    .enum(values)
    .or(unknownEnumValueSchema)
    // eslint-disable-next-line no-restricted-syntax -- I need to use catch
    .catch((_) => unknownEnumValueSchema.parse(UNKNOWN_ENUM_VALUE));
export const isUnknownEnumValue = (maybeUnknown) => {
    const unknownValue = maybeUnknown;
    return unknownValue === UNKNOWN_ENUM_VALUE;
};
